module.exports = __webpack_public_path__ + "img/beijing11.60ad1c8e.png";